import React, { Component } from "react";
import styled from "styled-components";
import CountrySelector from "./CountrySelector";
import FormField from "./FormField";
import { PortalFormDescription, PortalFormFieldGroup, PortalFormLabel } from "./PortalFormLayout";

const Description = styled(PortalFormDescription)`
    margin-bottom: 0.5rem;
`;

const BankFormField = styled(FormField)`
`;

const FieldGroup = styled(PortalFormFieldGroup)`
    gap: 0;
`;

const FieldLabel = styled(PortalFormLabel)`
    font-size: 0.875rem;
`;

export const ContainerGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.85rem 1rem;

    @media (max-width: 760px) {
        grid-template-columns: 1fr;
    }
`;

export const ErrorList = {
    UNKNOWN: 0,
    EMPTY_COUNTRY: 1,
    EMPTY_ACCOUNT_HOLDER_NAME: 2,
    EMPTY_BANK_NAME: 3,
    EMPTY_ACCOUNT_NUMBER: 4,
    EMPTY_SWIFT_CODE: 5,
    EMPTY_BSB_OR_IBAN: 6, 
    EMPTY_INVOICE_OR_STATEMENT_EMAIL: 7, 

    EMPTY_STREET_ADDRESS: 8, 
    EMPTY_CITY: 9, 
    EMPTY_STATE: 10, 
    EMPTY_ADDRESS_COUNTRY: 11, 
    EMPTY_POST_CODE_OR_ZIP: 12, 
    EMAIL_INVALID: 13,
    AUS_INVALID_ACCOUNT_NUMBER: 14,
    AUS_BSB_LENGTH: 15
};

export const returnErrorMessages = {
    [ErrorList.AUS_BSB_LENGTH]: "Please enter a 6-digit number for BSB.",
};

export const ErrorStrings = {
    
    [ErrorList.UNKNOWN]: "* Error unknown. Please contact support@memotivationapp.com",
    [ErrorList.EMPTY_COUNTRY]: "* Please enter a country",
    [ErrorList.EMPTY_ACCOUNT_HOLDER_NAME]: "* Please enter an account holder name",
    [ErrorList.EMPTY_BANK_NAME]: "* Please enter a bank name",
    [ErrorList.EMPTY_ACCOUNT_NUMBER]: "* Please enter an account number",
    [ErrorList.EMPTY_SWIFT_CODE]: "* Please enter a SWIFT code",
    [ErrorList.EMPTY_BSB_OR_IBAN]: "* Please enter a BSB or IBAN",
    [ErrorList.EMPTY_INVOICE_OR_STATEMENT_EMAIL]: "* Please enter an invoice or statement email",

    [ErrorList.EMPTY_STREET_ADDRESS]: "* Please enter a street",
    [ErrorList.EMPTY_CITY]: "* Please enter a city",
    [ErrorList.EMPTY_STATE]: "* Please enter a state",
    [ErrorList.EMPTY_ADDRESS_COUNTRY]: "* Please enter a country",
    [ErrorList.EMPTY_POST_CODE_OR_ZIP]: "* Please enter a postcode or zip",
    [ErrorList.EMAIL_INVALID]: "* Please enter a valid invoice or statement email",
    [ErrorList.AUS_INVALID_ACCOUNT_NUMBER]: "* Account number field accepts 4 to 12-digit number.",
    [ErrorList.AUS_BSB_LENGTH]: "* " + returnErrorMessages[ErrorList.AUS_BSB_LENGTH],
};

class BankCountry extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors } = this.props;
        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_COUNTRY);

        return (
            <>
                <FieldGroup>
                    <FieldLabel>
                        Country
                    </FieldLabel>
                
                    <CountrySelector 
                        value={bankAccountDetails.country}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "country");} }
                        errors={emptyFieldError}
                        showErrors={true}
                    />
                </FieldGroup>
            </>
        );
    }
}

class AddressCountry extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors } = this.props;
        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_ADDRESS_COUNTRY);

        return (
            <>
                <FieldGroup>
                    <FieldLabel>
                        Country
                    </FieldLabel>
                
                    <CountrySelector 
                        value={bankAccountDetails.addressCountry}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "addressCountry");} }
                        errors={emptyFieldError}
                        showErrors={true}
                    />
                </FieldGroup>
            </>
        );
    }
}

class AccountHolderName extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_ACCOUNT_HOLDER_NAME);

        return (
            <>
                <div>
                    <FieldLabel>
                    Account Holder Name
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Account Holder Name" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "accountHolderName");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.accountHolderName}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class BankName extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_BANK_NAME);

        return (
            <>
                <div>
                    <FieldLabel>
                    Bank Name
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Bank Name" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "bankName");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.bankName}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class AccountNumber extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_ACCOUNT_NUMBER, ErrorList.AUS_INVALID_ACCOUNT_NUMBER);
        return (
            <>
                <div>
                    <FieldLabel>
                    Account Number
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Account Number" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "accountNumber");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.accountNumber}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class SwiftCode extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, isSwiftCodeDisabled, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_SWIFT_CODE);

        return (
            <>
                <div>
                    <FieldLabel>
                    SWIFT Code
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={isSwiftCodeDisabled ? "n/a" : !placeholderDisabled ? "Enter SWIFT Code" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "swiftCode");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.swiftCode}
                        disabled={isSwiftCodeDisabled}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class BsbOrIban extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_BSB_OR_IBAN, ErrorList.AUS_BSB_LENGTH);

        return (
            <>
                <div>
                    <FieldLabel>
                    BSB/IBAN
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter BSB/IBAN" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "bsbOrIban");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.bsbOrIban}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class InvoiceOrStatementEmail extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;
        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_INVOICE_OR_STATEMENT_EMAIL, ErrorList.EMAIL_INVALID);

        return (
            <>
                <div>
                    <FieldLabel>
                    Invoice/Statement Email
                    </FieldLabel>

                    <Description>Enter the email address you would like to receive your earnings statements to.</Description>
                
                    <ContainerGrid>
                        <BankFormField
                            align="left"
                            width="100%"
                            type="text"
                            placeholder={!placeholderDisabled ? "Enter Invoice/Statement Email" : undefined}
                            onChange={(event) => {inputBankAccountDetailsValue(event, "invoiceOrStatementEmail");} }
                            errors={emptyFieldError}
                            showErrors={true}
                            maxLength="100"
                            value={bankAccountDetails.invoiceOrStatementEmail}
                        >
                        </BankFormField>
                    </ContainerGrid>
                </div>
            </>
        );
    }
}

class StreetAddress extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_STREET_ADDRESS);

        return (
            <>
                <div>
                    <FieldLabel>
                    Street Address
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Street Address" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "streetAddress");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.streetAddress}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class StreetAddress2nd extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, placeholderDisabled } = this.props;

        return (
            <>
                <div>
                    <FieldLabel>
                    Street Address 2 (optional)
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Street Address 2 (Optional)" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "streetAddress2");} }
                        errors={null}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.streetAddress2}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class City extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_CITY);

        return (
            <>
                <div>
                    <FieldLabel>
                    City
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter City" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "city");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.city}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class State extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_STATE);

        return (
            <>
                <div>
                    <FieldLabel>
                    State
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter State" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "state");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.state}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

class PostcodeOrZip extends Component {
    render() {
        const { bankAccountDetails, inputBankAccountDetailsValue, inputErrors, placeholderDisabled } = this.props;

        const getErrorStrings = (...errs) => inputErrors.filter(err => errs.includes(err)).map(err => ErrorStrings[err]);
        const emptyFieldError = getErrorStrings(ErrorList.EMPTY_POST_CODE_OR_ZIP);

        return (
            <>
                <div>
                    <FieldLabel>
                    Postcode/Zip
                    </FieldLabel>
                    <BankFormField
                        align="left"
                        width="100%"
                        type="text"
                        placeholder={!placeholderDisabled ? "Enter Postcode/Zip" : undefined}
                        onChange={(event) => {inputBankAccountDetailsValue(event, "postcodeOrZip");} }
                        errors={emptyFieldError}
                        showErrors={true}
                        maxLength="100"
                        value={bankAccountDetails.postcodeOrZip}
                    >
                    </BankFormField>
                </div>
            </>
        );
    }
}

export {
    BankCountry, 
    AddressCountry, 
    AccountHolderName, 
    BankName, 
    AccountNumber, 
    SwiftCode, 
    BsbOrIban, 
    InvoiceOrStatementEmail,
    StreetAddress,
    StreetAddress2nd,
    City,
    State,
    PostcodeOrZip
};
